import script from "./SessionListView.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionListView.vue?vue&type=script&setup=true&lang=js"

import "./SessionListView.vue?vue&type=style&index=0&id=61601b17&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61601b17"]])

export default __exports__